/**
 * ピンの持つ役割に関する情報
 */
export const PinSpotType = {
  ARTICLE_SPOT: {
    name: 'ARTICLE_SPOT',
    label: 'articleSpot',
    zIndex: 1,
    size: {
      width: 29,
      height: 41,
    }
  },
  FOCUS_SPOT: {
    name: 'FOCUS_SPOT',
    label: 'focusSpot',
    zIndex: 2,
    size: {
      width: 40,
      height: 58,
    }
  },
  USER_LOCATION: {
    name: 'USER_LOCATION',
    label: 'userLocation',
    zIndex: 1,
    size: {
      width: 30,
      height: 30,
    }
  },
  PLAN_MAP_VIEW_SPOT: {
    name: 'PLAN_MAP_VIEW_SPOT',
    label: 'planMapViewSpot',
    zIndex: 1,
    size: {
      width: 28,
      height: 40,
    }
  },
  PLAN_MAP_VIEW_SPOT_FOCUS: {
    name: 'PLAN_MAP_VIEW_SPOT_FOCUS',
    label: 'planMapViewSpotFocus',
    zIndex: 2,
    size: {
      width: 33,
      height: 49,
    }
  },
};

export {PinSpotType as default};
